import React from "react";
import { MapContainer, TileLayer, Popup, Circle } from 'react-leaflet'
import numeral from 'numeral'

function Map({center, zoom, countries, casesType}) {

  const casesTypeColors = {
  cases: {
    hex: "#CC1034",
    multiplier: 170,
  },
  recovered: {
    hex: "#7dd71d",
    multiplier: 180,
  },
  deaths: {
    hex: "#fb4443",
    multiplier: 1300,
  },
};

  return (
    <div className="map">
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} >
        <TileLayer 
        attribution='&copy; <a href="http://osm.org/copyright" >OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        {countries.map(country => (
          <Circle 
          center={[country.countryInfo.lat, country.countryInfo.long]}
          color = 'tranparent'
          fillColor={casesTypeColors[casesType].hex}
          fillOpacity={0.4}
          radius={Math.sqrt(country[casesType]) * casesTypeColors[casesType].multiplier}
          >
            <Popup>
              <div className="info-container">
                <div className="info-flag" style={{ backgroundImage: `url(${country.countryInfo.flag})`}}>
                </div>

                <div className="info-name">{country.country}</div>

                <div className="info-confirmed">
                Cases: {numeral(country.cases).format("0,0")}
                </div>

                <div className="info-recovered">
                Recovered: {numeral(country.recovered).format("0,0")}
                </div>

                <div className="info-deaths">
                Deaths: {numeral(country.deaths).format("0,0")}
                </div>
              </div>
            </Popup>
          </Circle>
        ))}

      </MapContainer>
    </div>
  );
}

export default Map;